/**
 * Shared display helpers for the notification bell dropdown and the full
 * Notification Center page, so new notification types (added in later
 * phases — payments, applications, late rent, etc.) only need an icon
 * mapped in one place.
 */

const TYPE_ICONS = {
  ticket_created: "bx bx-receipt",
  ticket_reply: "bx bx-message-dots",
  ticket_message: "bx bx-message-dots",
  ticket_resolved: "bx bx-check-circle",
  ticket_status: "bx bx-info-circle",
  property_message: "bx bx-conversation",
  payment_received: "bx bx-credit-card",
  rent_late: "bx bx-error-circle",
  application_submitted: "bx bx-file-find",
  listing_inquiry: "bx bx-message-square-dots",
  listing_feedback: "bx bx-star",
};

export function getNotificationIcon(type) {
  return TYPE_ICONS[type] || "bx bx-bell";
}

export function formatTimeAgo(date) {
  if (!date) return "";
  const now = new Date();
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin} min ago`;
  const diffHrs = Math.floor(diffMin / 60);
  if (diffHrs < 24) return `${diffHrs} hour${diffHrs > 1 ? "s" : ""} ago`;
  const diffDays = Math.floor(diffHrs / 24);
  return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
}

/** Resolves where a notification click should navigate — new `link` field
 * first, falling back to the old ticket-only shape for pre-existing docs. */
export function getNotificationLink(notification) {
  if (notification.link) return notification.link;
  if (notification.portalId && notification.ticketId) {
    return `/tickets/${notification.portalId}/${notification.ticketId}`;
  }
  return null;
}
